import React from 'react';

const SectionTabs = ({ sections, selectedSection, onChange }) => {
  return (
    <div className="mt-4 sm:hidden">
      <select
        className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-custom-orange"
        value={selectedSection}
        onChange={onChange}
      >
        {Object.entries(sections).map(([key, section]) => (
          <option key={key} value={key}>
            {section.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SectionTabs;
